import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { IHospital } from '../../types/hospital'

export interface IHospitalsState extends IAjaxBaseState<IHospital> {
}

const createInitialHospitalsState = (): IHospitalsState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialHospitalsState
}
